var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 18C9.25 22.8326 13.1674 26.75 18 26.75C22.8326 26.75 26.75 22.8326 26.75 18C26.75 13.1674 22.8326 9.25 18 9.25C13.1674 9.25 9.25 13.1674 9.25 18Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8753 9.29372C18.8753 9.29372 21.5003 12.75 21.5003 18C21.5003 23.25 18.8753 26.7062 18.8753 26.7062M17.1253 26.7062C17.1253 26.7062 14.5003 23.25 14.5003 18C14.5003 12.75 17.1253 9.29372 17.1253 9.29372M9.80151 21.0625H26.199M9.80151 14.9375H26.199",
    stroke: "#3D3D3D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLanguage);
export default __webpack_public_path__ + "static/media/Btn-Language.5876f3a5871ef4ebd81a82b78cb53999.svg";
export { ForwardRef as ReactComponent };